// @flow

import Honeybadger from '@honeybadger-io/js';
import { actionEntryPoints } from './actionEntryPoints';
import { onReady } from 'boot/common/domReady';
import { retrieve } from 'putki';

function buildModuleName(controller: string, action: string) {
  const camelCaseController = controller.replace(/(_\w)/g, match =>
    match[1].toUpperCase()
  );
  const upcaseAction = action.replace(/^./, match => match.toUpperCase());
  return `${camelCaseController}${upcaseAction}`;
}

function actionAlias(action: string): string {
  const crudAliases: { [string]: ?string } = {
    update: 'edit',
    create: 'new'
  };
  return crudAliases[action] || action;
}

function findScript(controller: string, action: string) {
  const moduleNameWithAction = buildModuleName(controller, actionAlias(action));
  const moduleNameWithoutAction = buildModuleName(controller, '');

  if (typeof actionEntryPoints[moduleNameWithAction] === 'function') {
    const actionFunc = actionEntryPoints[moduleNameWithAction];
    return actionFunc();
  }

  if (typeof actionEntryPoints[moduleNameWithoutAction] === 'function') {
    const actionFunc = actionEntryPoints[moduleNameWithoutAction];
    return actionFunc();
  }

  return Promise.resolve({ default: () => {} });
}

const controller = retrieve('controller');
const action = retrieve('action');

if (typeof controller === 'string' && typeof action === 'string') {
  findScript(controller, action)
    .then(module => module.default)
    .then(initializer => {
      onReady(() => {
        try {
          initializer();
        } catch (err) {
          Honeybadger.notify(err);
          // No caller catches this: it is inside an `onReady` callback, so
          // the rethrow surfaces as an uncaught error. That is what fails a
          // Cypress spec (`cypress/support/e2e.ts`) and what Datadog RUM
          // records for a sampled session. Honeybadger ignores uncaught
          // errors (`enableUncaught: false`), so the report above is the one
          // it gets.
          //
          // TODO: Handle an initializer error gracefully.
          throw err;
        }
      });
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error(err);
    });
}
